import React from 'react';
import * as PropTypes from 'prop-types';
import { Link } from '@material-ui/core';
import styles from './Header.module.less';
import Navigation from '../Navigation/Navigation';
import userSvg from '../../../../assets/images/user.svg';
import groupSvg from '../../../../assets/images/group.svg';

const Header = ({
  isLogin,
  userName,
  isShowConsole,
  isShowPrivilegedConsole,
  isShowPrivilegeCheckinConsole,
  isShowProductManagement,
  blackBgColor,
  title,
  isShowNavigation
}) => {
  return (
    <header
      className={`${styles.header} ${blackBgColor && styles['black-bg']}`}>
      <Link
        href={title === 'AWS' ? '/aws' : '/'}
        className={styles.logo}
        underline='none'>
        {title}
      </Link>
      {isShowNavigation && (
        <Navigation
          isLogin={isLogin}
          userName={userName}
          userSvg={userSvg}
          groupSvg={groupSvg}
          isShowConsole={isShowConsole}
          isShowPrivilegedConsole={isShowPrivilegedConsole}
          isShowPrivilegeCheckinConsole={isShowPrivilegeCheckinConsole}
          isShowProductManagement={isShowProductManagement}
          className='white'
        />
      )}
    </header>
  );
};

Header.defaultProps = {
  isShowPrivilegeCheckinConsole: false,
  blackBgColor: false,
  isShowProductManagement: false,
  isShowNavigation: true,
  title: 'ITT/XM Platform'
};

Header.propTypes = {
  isLogin: PropTypes.bool.isRequired,
  isShowConsole: PropTypes.bool.isRequired,
  userName: PropTypes.string.isRequired,
  isShowPrivilegedConsole: PropTypes.bool.isRequired,
  isShowPrivilegeCheckinConsole: PropTypes.bool,
  isShowProductManagement: PropTypes.bool,
  isShowNavigation: PropTypes.bool,
  blackBgColor: PropTypes.bool,
  title: PropTypes.string
};

export default Header;
